interface GeneratedExperienceCriteria {
    criteria: Array<string>;
}

export const DefaultExperienceCriteria: GeneratedExperienceCriteria = {
    criteria: [],
};

export default GeneratedExperienceCriteria;
